import MomentUtils from '@date-io/moment';
import { Button, TextField } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import _ from 'lodash';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import Select from 'react-select';
import { IState } from '../../redux/store';
import ReduxLanguage from "../ReduxLanguage";
import { Autocomplete } from '@material-ui/lab';
import translations from '../../translations/i18next';
import { ICustomerContractServiceFormDTO } from '../../repository/jago/model/input/ICustomerContractServiceFormDTO';
import { ICustomerServiceInDTO } from '../../repository/jago/model/input/ICustomerServiceInDTO';
import { CustomerContractServiceStatusOptions_ONEOFF, CustomerContractServiceStatusOptions_RECURRING } from '../../codec/customerContractServiceInDTODecoder';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import Utils from '../../utils/Utils';
import { CurrenciesEnum } from '../../repository/jago/model/output/ICurrenciesEnum';
import { GREEN } from '../../style/StyleConsts';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    height: '100%',
    flex: 1,
  },
  formTitle: {
    fontWeight: 'bold',
    marginBottom: 20,
  },
  errorText: {
    color: 'red'
  },
  inputTitle: {
    marginTop: 10,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  disabledButton: {
    backgroundColor: 'red'
  },
  inputTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  italicText: {
    fontStyle: 'italic',
  },
  customerDataColumn: {
    flex: 1,
  },
  actionButton: {
    width: 'fit-content',
    color: 'white',
    marginLeft: 20,
    padding: 4,
    paddingLeft: 10,
    paddingRight: 10,
    fontWeight: 'bold'
  },
  actionButtonText: {
    margin: 0,
    fontWeight: 'bold',
  },
  icon: {
    fontSize: 15,
    marginRight: 5,
  },
  iconCustomer: {
    marginRight: 5,
    fontSize: 25,
  },
  dateInput: {
    height: 33
  }
});

export interface ICustomerContractServiceFormState {
  customerContractService: ICustomerContractServiceFormDTO;
  errors: Record<keyof ICustomerContractServiceFormDTO, boolean>;
  selectedService: ICustomerServiceInDTO | null;
};

export interface ICustomerContractServiceFormProps extends WithStyles<typeof styles>{
  onCreateEditCustomerContractService: (customerContractService: ICustomerContractServiceFormDTO) => void;
  customerContractService?: ICustomerContractServiceFormDTO;
}

type IReduxProps = ConnectedProps<typeof connector>;

export type ComponentProps = ICustomerContractServiceFormProps & IReduxProps;
class CustomerContractServiceForm extends React.Component<ComponentProps, ICustomerContractServiceFormState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      customerContractService: props.customerContractService ? {
        ...props.customerContractService,
        price: Utils.isEmptyPrice(props.customerContractService.price) ? null : Utils.formatServicePrice(props.customerContractService.price),
        originalPrice: Utils.isEmptyPrice(props.customerContractService.originalPrice) ? null : Utils.formatServicePrice(props.customerContractService.originalPrice),
        currency: props.customerContractService.currency || CurrenciesEnum.EUR,
      } : {
        id: null,
        type: '',
        code: '',
        sellOutPONumber: '',
        sfdcId: '',
        subject: '',
        groupFamily: '',
        status: '',
        notes: '',
        activationDate: null,
        deactivationDate: null,    
        price: 0,
        originalPrice: 0,
        currency: CurrenciesEnum.EUR,
        quantity: 12,
        netPrice: 0,
      },
      errors: {
        id: null,
        type: null,
        code: null,
        sellOutPONumber: null,
        sfdcId: null,
        subject: null,
        groupFamily: null,
        status: null,
        notes: null,
        activationDate: null,
        deactivationDate: null,
        price: null,
        originalPrice: null,
        currency: null,
        quantity: null,
        netPrice: null,
      },
      selectedService: null,
    };
  }

  onChangeValue(field: keyof ICustomerContractServiceFormDTO, mandatory: boolean, value?: any) {
    const { customerContractService, errors } = this.state;
    this.setState({
      errors: { ...errors, [field]: !value && mandatory ? true : false }
    });
    (customerContractService as any)[field] = value;
    this.setState({ customerContractService });
  }

  onSubmitForm() {
    const { customerContractService } = this.state;
    if (!this.canSubmitForm()) {
      return;
    }
    const { onCreateEditCustomerContractService } = this.props;

    const formattedService = {
      ...customerContractService,
      price: Utils.isEmptyPrice(customerContractService.price) ? null : Utils.formatServicePrice(customerContractService.price),
      originalPrice: Utils.isEmptyPrice(customerContractService.originalPrice) ? null : Utils.formatServicePrice(customerContractService.originalPrice),
    };
    
    onCreateEditCustomerContractService(formattedService);
  }

  canSubmitForm() {
    const { customerContractService } = this.state;
    return (
      customerContractService.code && customerContractService.status && (customerContractService.type === 'RECURRING' ? (customerContractService.activationDate && customerContractService.deactivationDate) : true)
    );
  }


  onServiceSelection(service: ICustomerServiceInDTO | null) {
    const { customerContractService } = this.state;
    if (service) {
      const formattedPrice = Utils.formatServicePrice(service.price);
      const isOneOff = service.type === 'ONEOFF';
      customerContractService.subject = service.subject;
      customerContractService.groupFamily = service.groupFamily;
      customerContractService.type = service.type;
      customerContractService.code = service.code;
      customerContractService.originalPrice = formattedPrice;
      customerContractService.currency = CurrenciesEnum.EUR;
      customerContractService.quantity = isOneOff ? 1 : 12;
      this.setState({ 
        customerContractService,
        selectedService: service 
      });
    } else {
      this.setState({ selectedService: null });
    }
  }

  onQuantityChange(quantity: number) {
    const { customerContractService } = this.state;
    customerContractService.price = quantity * customerContractService.netPrice;
    this.setState({ customerContractService });
  }

  onNetPriceChange(netPrice: number) {
    const { customerContractService } = this.state;
    customerContractService.price = customerContractService.quantity * netPrice;
    this.setState({ customerContractService });
  }

  public render() {
    const { classes, staticServices } = this.props;
    const { customerContractService, errors, selectedService } = this.state;
    
    const isEdit = Boolean(this.props.customerContractService)
    const canEdit = (isEdit && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACT_SERVICES_UPDATE)) || 
      (!isEdit && AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACT_SERVICES_CREATE))

    const typeSelected = customerContractService.type || 'RECURRING';
    const statusOptions = typeSelected === 'RECURRING' ? CustomerContractServiceStatusOptions_RECURRING : CustomerContractServiceStatusOptions_ONEOFF;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale={moment.locale()}>
        <div className={classes.container}>
          <div style={{ padding: 5, paddingRight: 0, paddingLeft: 10, paddingTop: 0, marginBottom: 0, border: '1px solid #e0e0e0', borderRadius: 5 }}>
            <div style={{ marginBottom: 0 }}>
              {!isEdit ? (
                <div className={classes.inputTitle}>
                  <ReduxLanguage languageKey={'credits.selectService'} />
                  <span style={{ color: 'red' }}>*</span>
                </div>
              ) : (
                <div className={classes.inputTitle}>
                  <ReduxLanguage languageKey={'credits.contractService'} />
                </div>
              )}
              {!isEdit ? (
                <Autocomplete
                  id="service-search"
                  style={{ width: 'calc(100% - 10px)', marginTop: 20 }}
                  getOptionLabel={(option) => `${option.code||""} [${option.groupFamily||""}] - ${option.subject||""}`}
                  filterOptions={(options, { inputValue }) => 
                    options.filter(option => 
                      option.groupFamily.toLowerCase().includes(inputValue.toLowerCase()) || 
                      option.subject.toLowerCase().includes(inputValue.toLowerCase()) ||
                      option.code.toLowerCase().includes(inputValue.toLowerCase())
                    )
                  }
                  disabled={!canEdit}
                  options={staticServices || []}
                  autoComplete
                  includeInputInList
                  filterSelectedOptions
                  value={selectedService}
                  noOptionsText={<ReduxLanguage languageKey={'credits.noServicesFound'} />}
                  onChange={(event, newValue) => { this.onServiceSelection(newValue as ICustomerServiceInDTO | null); }}
                  renderInput={(params) => (
                    <TextField
                      autoComplete='off'
                      {...params}
                      variant="outlined"
                      placeholder={translations.t('credits.searchContractService')}
                    />
                  )}
                />
              ) : null}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
              <div style={{ flex: 0, marginRight: 10, flexGrow: 1 }}>
                <TextField
                  autoComplete='off'
                  id="outlined-basic"
                  label={<ReduxLanguage languageKey={'credits.serviceType'} />}
                  variant="outlined"
                  fullWidth
                  disabled={true}
                  value={customerContractService.type}
                  style={{ marginTop: 20 }}
                  onChange={e => this.onChangeValue('type', false, e.target.value)}
                />
              </div>
              <div style={{ flex: 0, marginRight: 10, flexGrow: 2 }}>
                <TextField
                  autoComplete='off'
                  id="outlined-basic"
                  label={<ReduxLanguage languageKey={'credits.serviceGroupFamily'} />}
                  variant="outlined"
                  fullWidth
                  disabled={true}
                  value={customerContractService.groupFamily}
                  style={{ marginTop: 20 }}
                  onChange={e => this.onChangeValue('groupFamily', false, e.target.value)}
                />
              </div>
              <div style={{ flex: 0, marginRight: 10, flexGrow: 2 }}>
                <TextField
                  autoComplete='off'
                  id="outlined-basic"
                  label={<ReduxLanguage languageKey={'credits.contractServiceCode'} />}
                  variant="outlined"
                  fullWidth
                  disabled={true}
                  value={customerContractService.code}
                  style={{ marginTop: 20 }}
                  onChange={e => this.onChangeValue('code', false, e.target.value)}
                />
              </div>
            </div>
            <div style={{ flex: 0, marginRight: 10 }}>
              <TextField
                autoComplete='off'
                id="outlined-basic"
                label={<ReduxLanguage languageKey={'credits.serviceSubject'} />}
                variant="outlined"
                fullWidth
                disabled={true}
                value={customerContractService.subject}
                style={{ marginTop: 20 }}
                onChange={e => this.onChangeValue('subject', false, e.target.value)}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 10, marginTop: 20 }}>
              <div style={{ flex: 0, minWidth: 160 }}>
                <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'credits.netPrice'} />
                  {/*<span style={{ color: 'red' }}>*</span>*/}
                </h4>
                <TextField
                  autoComplete='off'
                  id="outlined-basic"
                  variant="outlined"
                  fullWidth
                  type="number"
                  disabled={!canEdit || (!isEdit && !selectedService)}
                  error={errors.netPrice}
                  value={customerContractService.netPrice}
                  onChange={e => {
                    this.onChangeValue('netPrice', false, parseFloat(e.target.value));
                    this.onNetPriceChange(parseFloat(e.target.value));
                  }}
                  inputProps={{ step: 0.01 }}
                />
              </div>
              <div style={{ flex: 0, minWidth: 160 }}>
                <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'credits.quantity'} />
                  {/*<span style={{ color: 'red' }}>*</span>*/}
                </h4>
                <TextField
                  autoComplete='off'
                  id="outlined-basic"
                  variant="outlined"
                  fullWidth
                  type="number"
                  disabled={!canEdit || (!isEdit && !selectedService)}
                  error={errors.quantity}
                  value={customerContractService.quantity}
                  onChange={e => {
                    this.onChangeValue('quantity', false, parseFloat(e.target.value));
                    this.onQuantityChange(parseFloat(e.target.value));
                  }}
                  inputProps={{ step: 1 }}
                />
              </div>
              <div style={{ flex: 0, minWidth: 160, marginRight: 10 }}>
                <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'credits.contractServiceOriginalPrice'} />
                </h4>
                <TextField
                  autoComplete='off'
                  id="outlined-basic"
                  variant="outlined"
                  fullWidth
                  type="text"
                  disabled={true}
                  value={customerContractService.originalPrice ? (customerContractService.originalPrice || 0).toFixed(2) : '---'}
                  inputProps={{ step: 0.01 }}
                />
              </div>
              <div style={{ flex: 0, width: 90 }}>
                <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>
                  <ReduxLanguage languageKey={'credits.contractServiceCurrency'} />
                </h4>
                <Select
                  options={[{ value: CurrenciesEnum.EUR }]}
                  isSearchable={false}
                  isDisabled={true}
                  placeholder=""
                  getOptionLabel={(v) => v.value}
                  value={{ value: customerContractService.currency }}
                  onChange={() => {}}
                  styles={{
                    menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
                    control: (styles) => ({ ...styles, minHeight: 55, minWidth: 90 }),
                  }} 
                />
              </div>
            </div>
            <div style={{ width: 610, marginTop: 20, marginBottom: 20 }}>
              <h4 style={{ marginTop: 0, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>
                <ReduxLanguage languageKey={'credits.totalInvoicedWithExplanation'} />
                <span style={{ color: 'red' }}>*</span>
              </h4>
              <div style={{ padding: 10, backgroundColor: GREEN, borderRadius: 5, height: 40, alignItems: 'center', display: 'flex', marginBottom: 10 }}>
                <h3 style={{ color: 'white', fontWeight: 'bold', margin: 0 }}>{customerContractService.price} €</h3>
              </div>
            </div>
          </div>
          <h4 style={{ marginTop: 34, marginLeft: 0, marginBottom: 3, fontWeight: 'bold' }}>{<ReduxLanguage languageKey={'credits.customerContractServiceStatus'} />}<span style={{ color: 'red' }}>*</span></h4>
          <Select
            options={_.map(statusOptions, (v) => ({ value: v }))}
            isClearable
            isSearchable={false}
            placeholder={<ReduxLanguage languageKey={'credits.customerContractServiceStatus'} />}
            getOptionLabel={(v) => translations.t(`credits.customerContractServiceStatus_${v.value}`)}
            value={customerContractService.status ? { value: customerContractService.status } : null}
            onChange={(e) => this.onChangeValue('status', true, e ? e.value : null)}
            isDisabled={!canEdit}
            styles={{
              menu: (styles) => Object.assign(styles, { zIndex: 1000 }),
              control: (styles) => ({ ...styles, minHeight: 55, marginTop: 10, marginBottom: 10 }),
            }} 
          />
          {typeSelected !== 'ONEOFF' && (
            <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
              <div style={{ flex: 1 }}>
                <div style={{ marginLeft: 0 }}>
                  <h3 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3 }}>{<ReduxLanguage languageKey={'credits.customerContractActivationDate'} />}<span style={{ color: 'red' }}>*</span></h3>
                  <KeyboardDatePicker
                    disableToolbar
                    style={{ width: '100%' }}
                    variant="dialog"
                    format="DD/MM/YYYY"
                    margin="dense"
                    inputVariant="outlined"
                    inputProps={{
                      className: classes.dateInput
                    }}
                    clearable
                    disabled={!canEdit}
                    id="date-picker-inline"
                    placeholder={translations.t('forms.pickDate') + ' (dd/mm/yyyy)'}
                    value={customerContractService.activationDate ? moment(customerContractService.activationDate) : null}
                    onChange={e => this.onChangeValue('activationDate', true, e?.valueOf())}
                  />
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ marginLeft: 0 }}>
                  <h3 style={{ marginTop: 20, marginLeft: 0, marginBottom: 3 }}>{<ReduxLanguage languageKey={'credits.customerContractDeactivationDate'} />}<span style={{ color: 'red' }}>*</span></h3>
                  <KeyboardDatePicker
                    disableToolbar
                    style={{ width: '100%' }}
                    variant="dialog"
                    format="DD/MM/YYYY"
                    margin="dense"
                    inputVariant="outlined"
                    inputProps={{
                      className: classes.dateInput
                    }}
                    clearable
                    disabled={!canEdit}
                    id="date-picker-inline"
                    placeholder={translations.t('forms.pickDate') + ' (dd/mm/yyyy)'}
                    value={customerContractService.deactivationDate ? moment(customerContractService.deactivationDate) : null}
                    onChange={e => this.onChangeValue('deactivationDate', true, e?.valueOf())}
                  />
                </div>
              </div>
            </div>
          )}
          <div style={{ flex: 0, marginRight: 10 }}>
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerServiceSelloutPONumber'} />}
              variant="outlined"
              fullWidth
              disabled={!canEdit}
              error={errors.sellOutPONumber}
              value={customerContractService.sellOutPONumber}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('sellOutPONumber', false, e.target.value)}
            />
          </div>
          <div style={{ flex: 0, marginRight: 10 }}>
            <TextField
              autoComplete='off'
              id="outlined-basic"
              label={<ReduxLanguage languageKey={'credits.customerServiceSfdcId'} />}
              variant="outlined"
              fullWidth
              disabled={!canEdit}
              error={errors.sfdcId}
              value={customerContractService.sfdcId}
              style={{ marginTop: 20 }}
              onChange={e => this.onChangeValue('sfdcId', false, e.target.value)}
            />
          </div>
          <TextField
            multiline={true}
            maxRows={5}
            minRows={5}
            autoComplete='off'
            id="outlined-basic"
            label={<ReduxLanguage languageKey={'credits.customerContractServiceNotes'} />}
            variant="outlined"
            fullWidth
            disabled={!canEdit}
            error={errors.notes}
            value={customerContractService.notes}
            style={{ marginBottom: 20, marginTop:10 }}
            onChange={e => this.onChangeValue('notes', false, e.target.value)}
          />
          <div style={{ flex: 1, marginRight: 10 }}>
          </div>
          {canEdit && (
            <div style={{position:'sticky',bottom:'0',paddingTop:'20px',backgroundColor:'white',marginLeft:'-20px',marginRight:'-20px',zIndex:1}}>
              <Button
                variant="contained"
                disabled={!this.canSubmitForm()}
                style={{ width: '100%', opacity: this.canSubmitForm() ? 1 : 0.5, backgroundColor: '#5AC0B1', color: 'white', borderRadius: 0, height: 45, fontWeight: 'bold'  }}
                onClick={() => this.onSubmitForm()}
              >
                <ReduxLanguage languageKey="forms.save" />
              </Button>
            </div>
          )}
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    staticServices: state.credits.staticServices,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(CustomerContractServiceForm));